export const clinic = {
  brand: "Florida Family Clinic",
  legalName: "FLORIDA FAMILY CLINIC LLC",
  owner: "Ricardo Gutierrez",
  email: "ricardo@floridafamilyclinic.com",
  phone: "(509) 508-9985",
  phoneHref: "tel:+15095089985",
  addressLine: "1800 SW 27th Avenue",
  addressCity: "Miami, FL 33145",
  addressCountry: "United States",
  addressFull: "1800 SW 27th Avenue, Miami, FL 33145, United States",
  mapQuery: "1800 SW 27th Avenue, Miami, FL 33145",
  cityLabel: "Miami, Florida",
  mapEmbed:
    "https://www.google.com/maps?q=1800+SW+27th+Avenue,+Miami,+FL+33145&hl=en&output=embed",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&hl=en&destination=1800+SW+27th+Avenue%2C+Miami%2C+FL+33145",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About the Clinic", to: "/about" },
  { label: "Contact", to: "/contact" },
];